import { Languages, Moon, Sun } from 'lucide-react';
import { useI18n } from '@/i18n/context';
import { useTheme } from '@/theme/context';

/**
 * زرّ اللغة: يغيّر النصّ وحده — لا اتجاه ولا موضع قائمة يتغيّر.
 * `translate="no"`: عنوانُه مترجَمٌ أصلاً بـ`t()` ويحمل اسمَ اللغة بلسانها («العربية»)، فلا تمسُّه طبقةُ
 * الترجمة الحيّة — كانت تنقله بالنطق فيصير «Switch Language To al’rabia» (6 أكتوبر 2026).
 */
export function LangToggle() {
  const { lang, setLang, t } = useI18n();
  const next = lang === 'ar' ? 'en' : 'ar';
  const label = t('lang.switchTo', { next: t(next === 'ar' ? 'lang.ar' : 'lang.en') });
  return (
    <button type="button" className="pref-btn" onClick={() => setLang(next)} aria-label={label} title={label} translate="no">
      <Languages aria-hidden />
      <span className="pref-btn__code" dir="ltr">{next === 'en' ? 'EN' : 'AR'}</span>
    </button>
  );
}

/**
 * زرّ المظهر (أُعيد في 18 سبتمبر 2026) — **داخل المنصة وحدها**: الموقع العام
 * وبوابة الطفل مظهرُهما ثابت، فزرٌّ لا يغيّر شيئاً أسوأ من غيابه.
 */
export function ThemeToggle() {
  const { theme, surface, setTheme } = useTheme();
  const { t } = useI18n();
  if (surface !== 'app') return null;
  const next = theme === 'dark' ? 'light' : 'dark';
  const label = t(next === 'dark' ? 'theme.toDark' : 'theme.toLight');
  return (
    <button type="button" className="pref-btn" onClick={() => setTheme(next)} aria-label={label} title={label} translate="no">
      {theme === 'dark' ? <Sun aria-hidden /> : <Moon aria-hidden />}
    </button>
  );
}

/** التفضيلات — اللغة دائماً، والمظهر داخل المنصة */
export function Prefs({ className = '' }: { className?: string }) {
  return (
    <div className={`prefs ${className}`.trim()}>
      <ThemeToggle />
      <LangToggle />
    </div>
  );
}
